import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalGetActiveAlertsDocument = gql`
  query SalesPortalGetActiveAlerts($businessOrganizationUUID: uuid!) {
    getAllHubAlerts(
      business_organization_id: $businessOrganizationUUID
      filters: { alert_statuses: ACTIVE }
    ) {
      card_data_json
    }
  }
`;
export function useSalesPortalGetActiveAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >(SalesPortalGetActiveAlertsDocument, options);
}
export function useSalesPortalGetActiveAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >(SalesPortalGetActiveAlertsDocument, options);
}
export type SalesPortalGetActiveAlertsQueryHookResult = ReturnType<
  typeof useSalesPortalGetActiveAlertsQuery
>;
export type SalesPortalGetActiveAlertsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalGetActiveAlertsLazyQuery
>;
export type SalesPortalGetActiveAlertsQueryResult = Apollo.QueryResult<
  Types.SalesPortalGetActiveAlertsQuery,
  Types.SalesPortalGetActiveAlertsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalGetActiveAlertsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalGetActiveAlertsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >(SalesPortalGetActiveAlertsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalGetActiveAlertsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalGetActiveAlertsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalGetActiveAlertsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalGetActiveAlertsQuery,
    Types.SalesPortalGetActiveAlertsQueryVariables
  >(SalesPortalGetActiveAlertsDocument, lazyOptions);
}
